import { render } from "./pop-up.vue?vue&type=template&id=fd2fb358&scoped=true"
import script from "./pop-up.vue?vue&type=script&lang=js"
export * from "./pop-up.vue?vue&type=script&lang=js"

import "./pop-up.vue?vue&type=style&index=0&id=fd2fb358&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-fd2fb358"

export default script